import React, { useContext, useEffect, useState } from "react";
import query from "jquery";
import { Link, Navigate, NavLink, useLocation, useNavigate } from "react-router-dom";
import { userContext } from "../context/UserContext";
import { api_url, backend_domain } from "../helpers";

const Header = () => {
  const { user, setLoad, cart } = useContext(userContext);
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [scroll, setScroll] = useState(false);
  const [search, setSearch] = useState("");
  const [searchResult, setSearchResult] = useState([]);

    function useQuery() {
      const { search } = useLocation();
      return React.useMemo(() => new URLSearchParams(search), [search]);
    }
    const category = useQuery().get("category");

  useEffect(() => {
    window.onscroll = () => {
      if (window.pageYOffset < 150) {
        setScroll(false);
      } else if (window.pageYOffset > 150) {
        setScroll(true);
      }
      return () => (window.onscroll = null);
    };
    const selectElement = query(".js-example-basic-single");
    selectElement.select2();

    return () => {
      if (selectElement.data("select2")) {
        selectElement.select2("destroy");
      }
    };
  }, []);

  // Set the default language
  const [selectedLanguage, setSelectedLanguage] = useState("Eng");
  const handleLanguageChange = (language) => {
    setSelectedLanguage(language);
  };

  // Mobile menu support
  const [menuActive, setMenuActive] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const handleMenuClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  const handleMenuToggle = () => {
    setMenuActive(!menuActive);
  };

  // Search control support
  const [activeSearch, setActiveSearch] = useState(false);
  const handleSearchToggle = () => {
    setActiveSearch(!activeSearch);
  };

  // category control support
  const [activeCategory, setActiveCategory] = useState(false);
  const handleCategoryToggle = () => {
    setActiveCategory(!activeCategory);
  };
  const [activeIndexCat, setActiveIndexCat] = useState(null);
  const handleCatClick = (index) => {
    setActiveIndexCat(activeIndexCat === index ? null : index);
  };

  async function CategoriesData() {
    setLoad(true);

    const responsData = await fetch(
      api_url + "method/erp_sn.api.mega_menu.get_item_categories_with_groups",
      {
        headers: {
          Authorization: `token ${user?.api_key}:${user?.api_secret}`,
        },
      }
    );

    if (responsData.ok == true) {
      const data = await responsData.json();

      // console.log(data);

      if (data?.message?.length > 0) {
        setCategories(data?.message);
      }
    }

    setTimeout(() => {
      setLoad(false);
    }, 300);
  }

  useEffect(() => {
    CategoriesData();
  }, []);

  async function searchProduct(value) {
    const response = await fetch(
      api_url +
        `method/erp_sn.api.search.search_doctype_records?doctype=Item&limit=10&txt=${value}&field=item_name`,
      {
        headers: {
          Authorization: `token ${user?.api_key}:${user?.api_secret}`,
        },
      }
    );

    const data = await response.json();

    console.log(data);

    if (data?.message?.length > 0) {
      setSearchResult(data?.message);
    }
  }

  return (
    <>
      <div className="overlay" />
      <div
        className={`side-overlay ${(menuActive || activeCategory) && "show"}`}
      />
      {/* ==================== Search Box Start Here ==================== */}
      <form action="#" className={`search-box ${activeSearch && "active"}`}>
        <button
          onClick={handleSearchToggle}
          type="button"
          className="search-box__close position-absolute inset-block-start-0 inset-inline-end-0 m-16 w-48 h-48 border border-gray-100 rounded-circle flex-center text-white hover-text-gray-800 hover-bg-white text-2xl transition-1"
        >
          <i className="ph ph-x" />
        </button>
        <div className="container">
          <div className="position-relative">
            <input
              type="text"
              className="form-control py-16 px-24 text-xl rounded-pill pe-64"
              placeholder="Search for a product or brand"
            />
            <button
              type="submit"
              className="w-48 h-48 bg-main-600 rounded-circle flex-center text-xl text-white position-absolute top-50 translate-middle-y inset-inline-end-0 me-8"
            >
              <i className="ph ph-magnifying-glass" />
            </button>
          </div>
        </div>
      </form>
      {/* ==================== Search Box End Here ==================== */}
      {/* ==================== Mobile Menu Start Here ==================== */}
      <div
        className={`mobile-menu scroll-sm d-lg-none d-block ${
          menuActive && "active"
        }`}
      >
        <button
          onClick={() => {
            handleMenuToggle();
            setActiveIndex(null);
          }}
          type="button"
          className="close-button"
        >
          <i className="ph ph-x" />{" "}
        </button>
        <div className="mobile-menu__inner">
          <Link to="/" className="mobile-menu__logo">
            <img src="assets/images/logo/logo.png" alt="Logo" />
          </Link>
          <div className="mobile-menu__menu">
            {/* Nav Menu Start */}
            <ul className="nav-menu flex-align nav-menu--mobile">
              {/* Home Menu */}
              <li
                onClick={() => handleMenuClick(0)}
                className={`nav-menu__item ${
                  activeIndex === 0 ? "d-block" : ""
                }`}
              >
                <a href="/" className="nav-menu__link">
                  Home
                </a>
              
                <a href="/shop" className="nav-menu__link">
                  Shop Now
                </a>

                <a
                  href="/about"
                  className="nav-menu__link"
                  onClick={() => setActiveIndex(null)}
                >
                  About Us
                </a>
              </li>

              {/* Contact Us Menu */}
              <li className="nav-menu__item">
                <a
                  href="/contact"
                  className="nav-menu__link"
                  onClick={() => setActiveIndex(null)}
                >
                  Contact Us
                </a>
              </li>
            </ul>
            {/* Nav Menu End */}
          </div>
        </div>
      </div>
      {/* ==================== Mobile Menu End Here ==================== */}
      {/* ======================= Middle Top Start ========================= */}
      <div className="header-top bg-main-600 flex-between">
        <div className="container container-lg">
          <div className="flex-between flex-wrap gap-8">
            <ul className="flex-align flex-wrap d-none d-md-flex">
              <li className="border-right-item">
                <Link
                  to="#"
                  className="text-white text-sm hover-text-decoration-underline"
                >
                  Terms & Conditions
                </Link>
              </li>
              <li className="border-right-item">
                <Link
                  to="#"
                  className="text-white text-sm hover-text-decoration-underline"
                >
                  Privacy Policy
                </Link>
              </li>
            </ul>
            <ul className="header-top__right flex-align flex-wrap">
              <li className="on-hover-item border-right-item border-right-item-sm-space has-submenu arrow-white">
                {/* Display the selected language here */}
                <Link to="#" className="selected-text text-white text-sm py-8">
                  {selectedLanguage}
                </Link>
                <ul className="selectable-text-list on-hover-dropdown common-dropdown common-dropdown--sm max-h-200 scroll-sm px-0 py-8">
                  <li>
                    <Link
                      to="#"
                      className="hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
                      onClick={() => handleLanguageChange("English")}
                    >
                      <img
                        src="assets/images/thumbs/flag1.png"
                        alt=""
                        className="w-16 h-12 rounded-4 border border-gray-100"
                      />
                      English
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="#"
                      className="hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
                      onClick={() => handleLanguageChange("Japan")}
                    >
                      <img
                        src="assets/images/thumbs/flag2.png"
                        alt=""
                        className="w-16 h-12 rounded-4 border border-gray-100"
                      />
                      Arabic
                    </Link>
                  </li>
                  
                </ul>
              </li>
              <li className="border-right-item">
                <Link
                  to={
                    user?.name && user?.name != "guest"
                      ? "/dashboard"
                      : "/register"
                  }
                  className="text-white text-sm py-8 flex-align gap-6"
                >
                  <span className="icon text-md d-flex">
                    {" "}
                    <i className="ph ph-user-circle" />{" "}
                  </span>
                  <span className="hover-text-decoration-underline">
                    {user?.name && user?.name != "guest"
                      ? user?.name
                      : "Register"}
                  </span>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {/* ======================= Middle Top End ========================= */}

      {/* ======================= Middle Header Start ========================= */}
      <header className="header-middle bg-color-one border-bottom border-gray-100">
        <div className="container container-lg">
          <nav className="header-inner flex-between">
            {/* Logo Start */}
            <div className="logo">
              <Link to="/" className="link">
                <img src="assets/images/logo/logo.png" alt="Logo" />
              </Link>
            </div>
            {/* Logo End  */}
            {/* form location Start */}
            <form
              action="#"
              className="flex-align flex-wrap form-location-wrapper"
            >
              <div className="search-category d-flex h-48 select-border-end-0 radius-end-0 search-form d-sm-flex d-none">
                <div className="search-form__wrapper position-relative">
                  <input
                    type="text"
                    className="search-form__input common-input py-13 ps-16 pe-18 rounded-pill pe-44"
                    placeholder="Search for a product"
                    value={search}
                    onChange={(e) => {
                      setSearch(e.target.value);
                      setTimeout(() => {
                        searchProduct(e.target.value);
                      }, 300);
                    }}
                  />
                  <div className="w-32 h-32 bg-main-600 rounded-circle flex-center text-xl text-white position-absolute top-50 translate-middle-y inset-inline-end-0 me-8">
                    <i className="ph ph-magnifying-glass" />
                  </div>
                </div>
              </div>
              {searchResult?.length > 0 && search && (
                <div className="SearchResult overflow-y-auto scroll-sm">
                  {searchResult?.map((item, index) => (
                    <a
                      href={`/singleProduct?id=${item?.name}`}
                      style={{ width: "100%" }}
                    >
                      <div
                        key={index}
                        className="SearchResult-singleElem d-flex px-20 py-12"
                      >
                        <div className="me-30 d-flex justify-content-center align-items-center">
                          <img
                            src={`${backend_domain}${item?.images[0]}`}
                            className="search-img"
                          />
                        </div>
                        <div className="search-text">
                          <p>
                            <b>{item?.item_name}</b>
                          </p>
                          <p>
                            <b>{item?.prices[0]?.rate} KD</b>
                          </p>
                        </div>
                      </div>
                    </a>
                  ))}
                </div>
              )}
            </form>
            {/* form location start */}
            {/* Header Middle Right start */}
            <div className="header-right flex-align d-lg-block d-none">
              <div className="flex-align flex-wrap gap-12">
                <button
                  type="button"
                  className="search-icon flex-align d-lg-none d-flex gap-4 item-hover"
                >
                  <span className="text-2xl text-gray-700 d-flex position-relative item-hover__text">
                    <i className="ph ph-magnifying-glass" />
                  </span>
                </button>

                <Link to="/cart" className="flex-align gap-4 item-hover">
                  <span className="text-2xl text-gray-700 d-flex position-relative me-6 mt-6 item-hover__text">
                    <i className="ph ph-shopping-cart-simple" />
                    {cart?.items?.length > 0 && (
                      <span className="w-16 h-16 flex-center rounded-circle bg-main-600 text-white text-xs position-absolute top-n6 end-n4">
                        {cart?.items.reduce((sum, item) => sum + item.qty, 0)}
                      </span>
                    )}
                  </span>
                  <span className="text-md text-gray-500 item-hover__text d-none d-lg-flex">
                    Cart
                  </span>
                </Link>
              </div>
            </div>
            {/* Header Middle Right End  */}
          </nav>
        </div>
      </header>
      {/* ======================= Middle Header End ========================= */}
      {/* ==================== Header Start Here ==================== */}
      <header
        className={`header bg-white border-bottom border-gray-100 ${
          scroll && "fixed-header"
        }`}
      >
        <div className="container container-lg">
          <nav className="header-inner d-flex justify-content-between gap-8">
            <div className="flex-align menu-category-wrapper">
              {/* Category Dropdown Start */}
              <div className="category on-hover-item">
                <button
                  onClick={handleCategoryToggle}
                  type="button"
                  className="category__button flex-align gap-8 fw-medium p-16 border-end border-start border-gray-100 text-heading"
                >
                  <span className="icon text-2xl d-xs-flex d-none">
                    <i className="ph ph-dots-nine" />
                  </span>
                  <span className="d-sm-flex d-none">All</span> Categories
                  <span className="arrow-icon text-xl d-flex">
                    <i className="ph ph-caret-down" />
                  </span>
                </button>
                <div
                  className={`responsive-dropdown cat on-hover-dropdown common-dropdown nav-submenu p-0 submenus-submenu-wrapper ${
                    activeCategory && "active"
                  }`}
                >
                  <button
                    onClick={() => {
                      handleCategoryToggle();
                      setActiveIndexCat(null);
                    }}
                    type="button"
                    className="close-responsive-dropdown rounded-circle text-xl position-absolute inset-inline-end-0 inset-block-start-0 mt-4 me-8 d-lg-none d-flex"
                  >
                    {" "}
                    <i className="ph ph-x" />{" "}
                  </button>
                  {/* Logo Start */}
                  <div className="logo px-16 d-lg-none d-block">
                    <Link to="/" className="link">
                      <img src="assets/images/logo/logo.png" alt="Logo" />
                    </Link>
                  </div>
                  {/* Logo End */}
                  <ul className="scroll-sm p-0 py-8 w-300 max-h-400 overflow-y-auto">
                    {categories?.length > 0 &&
                      categories?.map((item, index) => {
                        return (
                          <li
                            // onClick={() => handleCatClick(1)}
                            key={index}
                            className={`has-submenus-submenu ${
                              activeIndexCat === 1 ? "active" : ""
                            }`}
                          >
                            <Link
                              className="text-gray-500 text-15 py-12 px-16 flex-align gap-8 rounded-0"
                            >
                              <span className="text-xl d-flex">
                                <i className="ph ph-brandy" />
                              </span>
                              <span>{item?.category_name}</span>
                              <span className="icon text-md d-flex ms-auto">
                                <i className="ph ph-caret-right" />
                              </span>
                            </Link>
                            <div
                              style={{ width: "500px" }}
                              className={`submenus-submenu py-12 ${
                                activeIndexCat === 1 ? "open" : ""
                              }`}
                            >
                              <div className="row">
                                {item?.item_groups?.length > 0 &&
                                  item?.item_groups?.map(
                                    (group, group_index) => (
                                      <div className="col-md-6">
                                        {/* <Link> */}            
                                        <a href={`/shop?category=${group}`}
                                          key={group_index}
                                          className="text-lg px-16 submenus-submenu__title sub-category-custom"
                                        >
                                          {group}
                                        </a>
                                        {/* </Link> */}
                                      </div>
                                    )
                                  )}
                              </div>
                            </div>
                          </li>
                        );
                      })}
                  </ul>
                </div>
              </div>
              {/* Category Dropdown End  */}
              {/* Menu Start  */}
              <div className="header-menu d-lg-block d-none">
                {/* Nav Menu Start */}
                <ul className="nav-menu flex-align ">
                  <li className="nav-menu__item">
                    <Link to="/" className="nav-menu__link">
                      Home
                    </Link>
                  </li>

                  <li className="nav-menu__item">
                    <Link to="/shop" className="nav-menu__link">
                      Shop Now
                    </Link>
                  </li>

                  <li className="nav-menu__item">
                    <Link to="/about" className="nav-menu__link">
                      About Us
                    </Link>
                  </li>

                  <li className="nav-menu__item">
                    <NavLink
                      to="/contact"
                      className={(navData) =>
                        navData.isActive
                          ? "nav-menu__link activePage"
                          : "nav-menu__link"
                      }
                    >
                      Contact Us
                    </NavLink>
                  </li>
                </ul>
                {/* Nav Menu End */}
              </div>
              {/* Menu End  */}
            </div>
            {/* Header Right start */}
            <div className="header-right flex-align">
              <Link
                to="/tel:+96512345678"
                className="bg-main-600 text-white p-12 h-100 hover-bg-main-800 flex-align gap-8 text-lg d-lg-flex d-none "
              >
                <div className="d-flex text-32">
                  <i className="ph ph-phone-call" />
                </div>
                +965 12345678
              </Link>
              <div className="me-16 d-lg-none d-block">
                <div className="flex-align flex-wrap gap-12">
                  <button
                    onClick={handleSearchToggle}
                    type="button"
                    className="search-icon flex-align d-lg-none d-flex gap-4 item-hover"
                  >
                    <span className="text-2xl text-gray-700 d-flex position-relative item-hover__text">
                      <i className="ph ph-magnifying-glass" />
                    </span>
                  </button>

                  <Link to="/cart" className="flex-align gap-4 item-hover">
                    <span className="text-2xl text-gray-700 d-flex position-relative me-6 mt-6 item-hover__text">
                      <i className="ph ph-shopping-cart-simple" />
                      {cart?.items?.length > 0 && (
                        <span className="w-16 h-16 flex-center rounded-circle bg-main-600 text-white text-xs position-absolute top-n6 end-n4">
                          {cart?.items.reduce((sum, item) => sum + item.qty, 0)}
                        </span>
                      )}
                    </span>
                    <span className="text-md text-gray-500 item-hover__text d-none d-lg-flex">
                      Cart
                    </span>
                  </Link>
                </div>
              </div>
              <button
                onClick={handleMenuToggle}
                type="button"
                className="toggle-mobileMenu d-lg-none ms-3n text-gray-800 text-4xl d-flex"
              >
                {" "}
                <i className="ph ph-list" />{" "}
              </button>
            </div>
            {/* Header Right End  */}
          </nav>
        </div>
      </header>
      {/* ==================== Header End Here ==================== */}
    </>
  );
};

export default Header;
